import { createFeature, createReducer, on } from '@ngrx/store';
import { CartItemsDataV2 } from 'thkee-common';
import { initialCartStateV2 } from './cart-state.model';
import { CartActionsV2 } from './cart.actions';

export const cartReducerV2 = createReducer(
  initialCartStateV2,
  on(CartActionsV2.loadCartSuccess, (state, { cartItems }) => {
    return cartItems;
  }),
  on(CartActionsV2.addToCartSuccess, (state, { cartItems }) => {
    return cartItems;
  }),
  on(CartActionsV2.removeToCartSuccess, (state, { cartItems }) => {
    return cartItems;
  }),
  on(CartActionsV2.initUserCartSuccess, (state, { cartItems }) => {
    return cartItems;
  }),
  on(CartActionsV2.cleanUserCartSuccess, (state) => {
    return initialCartStateV2;
  }),

  // Update wishlist items
  on(CartActionsV2.updateCartFavorite, (state, { item }) => {
    state = JSON.parse(JSON.stringify(state));
    let index = state.coursesData.findIndex((product: CartItemsDataV2) => product.id === item.id);
    state.coursesData[index].favorite = item.favorite;
    return {
      ...state,
      coursesData: [...state.coursesData],
    };
  }),

  on(CartActionsV2.updateCartSummary, (state, { summary }) => {
    return {
      ...state,
      cartSummary: summary,
    };
  })
);

export const cartFeatureV2 = createFeature({
  name: 'cart',
  reducer: cartReducerV2,
});
